defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Avatar',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils'
  ],
  function (m, Utils) {
    // Context:
    var Avatar = function (args) {
      var isChairman = args.isChairman;
      var name = args.name;
      var image = args.image;
      var label = args.value || Utils.shortenPlayerName(name);

      // Return:
      return m('.play-together__avatar', [
        isChairman ? m('svg.play-together__avatar-chairman-icon', m('use', { href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#crown' })) : null,
        m('.play-together__avatar-inner', [
          m('.play-together__avatar-label', label),
          image ? m('.play-together__avatar-image') : null
        ])
      ]);
    };

    // Public functions:
    return Avatar;
  });